export default __webpack_public_path__ + "static/media/type1.e89f5055.png";